export { BsModalRef } from './bs-modal-ref.service';
export { ModalBackdropOptions } from './modal-backdrop.options';
export { ModalContainerComponent } from './modal-container.component';
export { ModalBackdropComponent } from './modal-backdrop.component';
export { ModalOptions } from './modal-options.class';
export { ModalDirective } from './modal.directive';
export { ModalModule } from './modal.module';
export { BsModalService } from './bs-modal.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-bootstrap/modal/index.js
// module id = ../../../../ngx-bootstrap/modal/index.js
// module chunks = 7